import type { RowSelectionState } from '@tanstack/react-table';

export function getSelectedRowIds(rowSelection: RowSelectionState): Array<string> {
  return Object.keys(rowSelection).filter((id) => rowSelection[id]);
}

export function areAllCurrentPageRowsSelected<T extends { _id: string }>(
  currentPage: Array<T>,
  rowSelection: RowSelectionState,
): boolean {
  return (
    currentPage.length > 0 &&
    currentPage.every((row) => Boolean(rowSelection[row._id]))
  );
}

export function mergeSelectionCache<T extends { _id: string }>(
  cache: Record<string, T>,
  currentPage: Array<T>,
  rowSelection: RowSelectionState,
): Record<string, T> {
  const next: Record<string, T> = {};
  for (const id of getSelectedRowIds(rowSelection)) {
    const row = currentPage.find((item) => item._id === id) ?? cache[id];
    if (row) {
      next[id] = row;
    }
  }
  return next;
}

export function resolveSelectedRows<T extends { _id: string }>(
  rowSelection: RowSelectionState,
  currentPage: Array<T>,
  cache: Record<string, T>,
): Array<T> {
  return getSelectedRowIds(rowSelection)
    .map((id) => cache[id] ?? currentPage.find((row) => row._id === id))
    .filter((row): row is T => row != null);
}
